import { render, staticRenderFns } from "./SubmitTextfield.vue?vue&type=template&id=0a7e46b6&scoped=true&"
import script from "./SubmitTextfield.vue?vue&type=script&lang=ts&"
export * from "./SubmitTextfield.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7e46b6",
  null
  
)

export default component.exports